// extracted by mini-css-extract-plugin
export var boldText = "_35-4";
export var checkboxContainer = "_35-6";
export var closeIcon = "_35-i";
export var container = "_35-0";
export var drawer = "_35-8";
export var drawerContent = "_35-9";
export var extraSmallText = "_35-5";
export var fulfillmentGroupTable = "_35-e";
export var largeText = "_35-3";
export var loadingSpinnerContainer = "_35-j";
export var mediumText = "_35-2";
export var narrow = "_35-f";
export var notificationLink = "_35-l";
export var packageCheckIconContainer = "_35-7";
export var slideoutHeaderActions = "_35-g";
export var slideoutHeaderActionsShifted = "_35-h";
export var slideoutHeaderContainer = "_35-a";
export var slideoutModal = "_35-c";
export var stickyHeaderWrapper = "_35-b";
export var table = "_35-k";
export var tableContainer = "_35-d";
export var tertiaryText = "_35-1";